import { HELP_CENTRE_LOCALISED_URL } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import {
  Actions,
  Box,
  Button,
  Heading,
  IconChevron,
  Text,
  Stack,
} from 'braid-design-system';
import React, { useEffect } from 'react';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import { useSite } from 'src/shared/hooks';
import type { SitesAll } from 'src/shared/types';
import { trackEvent } from 'src/utils/trackEvent';

import translations from './.vocab';

const ThanksView = ({ clearSubmitted }: any) => {
  const site: SitesAll = useSite();
  const { t } = useTranslations(translations);
  useEffect(() => {
    const eventName = 'content_element_displayed';
    const trackingProps = {
      eventName,
      currentPage: 'feedback success',
      siteSection: 'candidate contact us',
      elementText: 'feedback submitted',
    };
    trackEvent(eventName, trackingProps, 'view');
  });
  const typedSite = site as keyof typeof HELP_CENTRE_LOCALISED_URL;

  return (
    <Stack space="gutter">
      <Heading level="3">{t('Thanks for contacting us')}</Heading>
      <Text>
        {t('Well try to reply to your enquiry within 1 business day.')}
      </Text>
      <Text>
        {t(
          'If you need to speak to us urgently, please refer to the Contact Us page for our telephone numbers.',
        )}{' '}
      </Text>
      <Text>
        {t('You can also search for answers in our Help Centre', {
          TextLink: (children) => (
            <TextLink
              href={HELP_CENTRE_LOCALISED_URL[typedSite].en}
              tracking={TRACKING_CODES.can_help_centre_link_clicked}
              eventProperties={{
                eventName: 'content_element_pressed',
                currentPage: 'feedback start',
                siteSection: 'candidate contact us',
                linkName: 'candidate-help-centre-link-clicked',
                linkText: 'candidate help centre',
              }}
            >
              {children}
            </TextLink>
          ),
        })}
        .
      </Text>
      <Box paddingTop="gutter">
        <Actions>
          <Button onClick={clearSubmitted} variant="ghost">
            <IconChevron direction="left" /> {t('Back to Contact Us page')}
          </Button>
        </Actions>
      </Box>
    </Stack>
  );
};

export default ThanksView;
